import { Navigate, useNavigate } from 'react-router-dom';
import { Fragment, useContext } from 'react';
import { AuthContext } from '../Context/UserContext';

const RequireAuth = ({ element: Element, allowedRoles }) => {
  const { user, token ,profileId} = useContext(AuthContext);
  const isAuthenticated = !!token;

  if (!isAuthenticated ) {
    return <Navigate to="/" replace />;
  }
 
  // if(isAuthenticated && !profileId)
  // {
  //   return <Navigate to="/profile" replace />;
  // }
  // if (profileId) {
  //   return <Navigate to="/home" replace />;
  // }
  // if (isAuthenticated && !profileId) {
  //   return <Navigate to="/profile" replace />;
  // }

  return (
    <Fragment>
      <Element />
    </Fragment>
  );
};

export default RequireAuth;
